import React, { useState } from 'react';
import { useAuth } from '../hooks/useAuth';
import VerifyEmailGate from './VerifyEmailGate';
import { BOOKING_BG } from '../constants/booking';
import { SECTION_PADDING } from '../styles/layout';

export default function RequireVerifiedEmail({ children }) {
  const { user, loading } = useAuth();
  const [verifiedOverride, setVerifiedOverride] = useState(false);

  if (loading) {
    return (
      <div style={{
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        backgroundColor: BOOKING_BG, color: '#F5F0E8',
        fontSize: '1.2rem', padding: SECTION_PADDING, minHeight: '40vh',
      }}>
        Loading…
      </div>
    );
  }

  if (!user) return children;

  if (!user.emailVerified && !verifiedOverride) {
    return <VerifyEmailGate onVerified={() => setVerifiedOverride(true)} />;
  }

  return children;
}
